import { IFileList, IModule } from "../models";
import { ICommunity } from "../models/channel";
import instance from "../utils/instance";

export const fetchConfigFiles = (location?: string): Promise<ICommunity> => {
  return instance.get(
    `file/configuration${(location && `?gpsLocation=${location}`) || ""}`
  );
};

export const fetchPermittedChannel = (): Promise<Array<IModule>> => {
  return instance.get("file/modules");
};

export const fetchFilesByChannel = (
  channel: string
): Promise<Array<IFileList>> => {
  return instance.get(`files?channel=${channel}`);
};
